module.exports = __webpack_public_path__ + "img/toAllocated.b9821c1e.png";